/* THE ILLUMINATEE — keep the newsletter success message in view.
   Shopify reloads the page after a successful customer-form submission and
   initially restores the form anchor before the final footer layout is ready.
   Repositioning after load/font settling prevents later layout shifts from
   leaving "Thanks for subscribing!" below the viewport. */
(function () {
  'use strict';

  var successSelector = '[id^="Email-signup__message-success-"]';

  function keepSuccessVisible() {
    var success = document.querySelector(successSelector);
    if (!success) return;

    function positionSuccess() {
      var documentBottom = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );

      window.scrollTo({
        top: documentBottom,
        left: 0,
        behavior: 'auto'
      });

      requestAnimationFrame(function () {
        var rect = success.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          success.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'nearest'
          });
        }
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(positionSuccess);
    });

    function positionAfterLoad() {
      positionSuccess();
      window.setTimeout(positionSuccess, 250);
      window.setTimeout(positionSuccess, 1000);
    }

    if (document.readyState === 'complete') positionAfterLoad();
    else window.addEventListener('load', positionAfterLoad, { once: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(positionSuccess);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepSuccessVisible, { once: true });
  } else {
    keepSuccessVisible();
  }
})();
